import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { useStoreState } from 'easy-peasy';
import { isNull } from 'lodash';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import client from '../../../utils/apolloClient';

const deleteUserMenuDealMutation = gql`
  mutation deleteUserMenuDealMutation($input: NavigateUserMenuDealInput) {
    delete_user_menu_deal(input: $input) {
      error {
        description
      }
    }
  }
`;

const Delete = ({
  menu_deal_id,
  user_specific_deal = true,
  targeted_users,
}) => {
  const { userId } = useStoreState(state => state.auth);

  return (
    <Mutation
      client={client.clientPrivate}
      mutation={deleteUserMenuDealMutation}
      onCompleted={({ delete_user_menu_deal }) => {
        if (!isNull(delete_user_menu_deal.error)) {
          delete_user_menu_deal.error.map(item =>
            toast.error(item.description),
          );
        } else {
          toast.success('User Promo deleted successfully!');
          window.location.reload(true);
        }
      }}
    >
      {(delete_user_menu_deal, { loading }) => (
        <button
          className={`button ${loading && 'is-loading'}`}
          onClick={() => {
            swal({
              title: 'Are you sure?',
              // eslint-disable-next-line max-len
              text: `Are you sure you want to delete this User Promo`,
              buttons: ['Cancel', 'Yes'],
              dangerMode: true,
            }).then(willDelete => {
              if (willDelete) {
                delete_user_menu_deal({
                  variables: {
                    input: {
                      user_id: userId,
                      menu_deal_id,
                      user_specific_deal,
                      targeted_users,
                    },
                  },
                });
              }
            });
          }}
        >
          <i className="fas fa-trash has-text-grey" />
        </button>
      )}
    </Mutation>
  );
};

export default Delete;
